export const getIntervalOptions = (t) => {
  return [
    { value: 1, label: t("frequentItems.daily") },
    { value: 7, label: t("frequentItems.weekly") },
    { value: 14, label: t("frequentItems.biWeekly") },
    { value: 30, label: t("frequentItems.monthly") },
    { value: 90, label: t("frequentItems.quarterly") },
    { value: 180, label: t("frequentItems.semiAnnually") },
    { value: 365, label: t("frequentItems.annually") },
  ];
};
